import { SxProps } from '@mui/material';
import { formatPercentage } from 'components/featured/Deals/components/DealDetailsMain/Details/utils';
import { formatDealAmount } from 'helper/short-currency';
import zeplinColor from 'theme/Color';

export const statisticsData = (activeDealCount: number, wonValue: number, successRate: number) => [
  { value: activeDealCount, formattedValue: activeDealCount, label: 'Active Deals' },
  {
    value: wonValue,
    formattedValue: formatDealAmount(wonValue),
    label: 'Total Spend',
  },
  {
    value: successRate,
    formattedValue: formatPercentage(String(successRate)),
    label: 'Success Rate',
  },
];

export const widgetValue = (value: number): SxProps => {
  let color = zeplinColor.Error;

  if (value > 90) {
    color = zeplinColor.Success;
  }

  if (value < 90 && value > 30) {
    color = zeplinColor.AlertInfo;
  }

  return { color };
};
